import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import { countDailyOperatingVehiclesService } from "../services/countDailyOperatingVehicles.service.js";
import debounce from "lodash.debounce";

export const useCountDailyOperatingVehiclesQuery = (filters) => {
  const fetchData = useFetch();
  const [countDailyOperatingVehicles, setCountDailyOperatingVehicles] =
    useState(0);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        setLoading(true);
        const response = await countDailyOperatingVehiclesService(fetchData)({
          filters,
        });

        setCountDailyOperatingVehicles(response.dailyOperatingVehicles);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchCount, 500);
    debounced();
    return () => {
      debounced.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters?.startDate, filters?.endDate]);

  return {
    countDailyOperatingVehicles,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
